import React, {useMemo, useEffect, useState} from 'react';
import '../App.css';

import Message from './Message';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
}


function DeploymentCard(props) {
    const random = useMemo(() => Math.random(), []);
    const random2 = useMemo(() => Math.random(), []);
    const getImageName = (path) => {
        const filename = path.split('/').pop(); 
        const name = filename.split('.')[0];    
        return name;
    };
    const isMobile = useIsMobile();
    const [messages, setMessages] = useState([]);

    const [toastMessage, setToastMessage] = useState('');
    const CopyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
        props.showToast(`Copied ${text} to clipboard!`);
    });
  };



  return (
    <>
       <div className="card" style={{ width: isMobile ? "85%" : "25%", margin: "auto", marginTop: "20px" }}>
            <img src={props.image} className="card-img-top" alt="Loading..."  />
            <div class="card-body">
                <h5 class="card-title">{props.title}</h5>
                <p class="card-text">{props.description}</p>
                <div className="container">
                <div className="row">
                
                <br />
                <p class="d-inline-flex gap-1" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%"}}>
                    <a download={props.title} href={props.image} className="btn btn-outline-primary" role="button" style={{width: "100%"}} >Download Image</a>
                    <a class="btn btn-outline-secondary" data-bs-toggle="collapse" href={"#" + random} role="button" aria-expanded="false" aria-controls={random} >
                        Attendees
                    </a>
                </p>
                <div className="collapse" id={random}>
                
                    <ul className="list-group">
                        {props.attendees.map((attendee, index) => (
                            <li className="list-group-item d-flex align-items-center justify-content-between" key={index}>
                                {attendee}
                                <button type="button" class="btn btn-outline-secondary" style={{textAlign: "center", float: "right"}} onClick={onClick => {CopyToClipboard(attendee)}}>Copy</button>
                            </li>
                        ))}
                    </ul>
                    
                </div>
                <hr class="my-4" />
                    <style>
                    </style>
                    {props.medals.map((medal, index) => (
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 mb-2 d-flex justify-content-center position-relative" key={index}>
                        <img
                        src={medal}
                        alt={`Medal ${index}`}
                        className="img-fluid rounded"
                        style={{
                            width: "100%",
                            height: "auto", 
                            objectFit: "fill",
                            margin: "0 auto",
                            border: "2px solid silver",
                        }}
                        />
                        <div className="overlay-text position-absolute top-50 start-50 translate-middle text-white text-center">
                            <p>{getImageName(medal)}</p>
                        </div>
                    </div>
                    ))}

                    {props.campaignMedals.map((medal, index) => (
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 mb-2 d-flex justify-content-center position-relative" key={index}>
                        <img
                        src={medal}
                        alt={`Medal ${index}`}
                        className="img-fluid rounded"
                        style={{
                            width: "100%",
                            height: "auto", 
                            objectFit: "fill",
                            margin: "0 auto",
                            border: "2px solid gold",
                            
                            
                        }}
                        />
                        <div className="overlay-text position-absolute top-50 start-50 translate-middle text-white text-center">
                            <p>{getImageName(medal)}</p>
                        </div>
                    </div>
                    ))}
                    
                </div>
                </div>
                
            </div>
        </div>
       
        
    </>
  );
}

export default  DeploymentCard;